export default function ableToModify(testId,userId){
    // Aksha , Amit, Vanshita
    let eliteUsers = ["6655d9b40777525410c88982","6655da0d21d3e92d1b400e27","651bd4c8ad7773279c5ae380"];
    if(eliteUsers.includes(userId)){
        return true
    }
    if(testId == userId){
        return true
    }
    return false;
}